module.exports = __webpack_public_path__ + "Roboto-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.woff2
// module id = 99
// module chunks = 0